import React, { useState, useEffect } from 'react';
import { useAgentApi } from '../Services/AgentApiProvider';
import { useAlert } from './AlertContext';
import { CustomInput, CustomTextarea, CustomToggle } from './CustomFormElements';
import Button from './Buttons';

function AgentInstructionEdit({ agentId, canEdit, initialData, onClose, onUpdate, onUpdateTrigger }) {
    const { showAlert } = useAlert();
    const { createAgentInstruction, updateAgentInstruction } = useAgentApi();

    const isNew = !initialData.id;

    const [originalText, setOriginalText] = useState('');
    const [instruction, setInstruction] = useState('');
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        setOriginalText(initialData.original_text || '');
        setInstruction(initialData.instruction || '');
        setIsActive(initialData.is_active);
    }, [initialData]);

    const handleSave = async () => {
        const payload = { original_text: originalText, instruction, is_active: isActive };
        try {
            if (isNew) {
                await createAgentInstruction(agentId, payload);
            } else {
                await updateAgentInstruction(agentId, initialData.id, payload);
            }
            if (onUpdate) onUpdate();
            onUpdateTrigger();
        } catch (error) {
            showAlert('fail', 'Failed to save instruction.');
        }
    };

    return (
        <div className="d-flex flex-column h-100">
            <h2 className='h4-title'>{isNew ? 'Create New Instruction' : 'Edit Instruction'}</h2>

            <div style={{flexGrow: 1, paddingTop: '1rem'}}>
                <div className="input-block d-flex flex-row justify-between">
                    <div className="input-description">
                        <div className="input-title">Original Text</div>
                        <div className="small-font">Enter original text, or query</div>
                    </div>
                    <div className="align-wrapper d-flex align-center">
                        <CustomInput
                            id="original-text"
                            label="Original Text"
                            placeholder="Enter original text or query"
                            value={originalText}
                            onChange={(id, value) => setOriginalText(value)}
                            disabled={!canEdit}
                        />
                    </div>
                </div>
                <div className="input-block d-flex flex-row justify-between">
                    <div className="input-description">
                        <div className="input-title">Instruction</div>
                        <div className='small-font'>Add instruction for Agent</div>
                    </div>
                    <div className="align-wrapper d-flex align-center">
                        <CustomTextarea
                            id="instruction"
                            label="Instruction"
                            name="instruction"
                            type="text"
                            addedText={instruction}
                            onChange={(value) => setInstruction(value)}
                            resizable={false}
                            disabled={!canEdit}
                            height="200px"
                        />
                    </div>
                </div>
                <div className="input-block d-flex flex-row justify-between">
                    <div className='input-description'>
                        <div className='input-title'>Activate Instruction</div>
                        <div className='small-font'>Set agent instruction to be active or inactive to enable or disable it
                        </div>
                    </div>
                    <div className='align-wrapper d-flex align-center'>
                        <CustomToggle
                            id="toggle-status"
                            label={isActive ? 'Active' : 'Inactive'}
                            checked={isActive}
                            onChange={(id, value) => setIsActive(value)}
                            disabled={!canEdit}
                        />
                    </div>
                </div>
            </div>

            <div className="buttons-container d-flex justify-end">
                {canEdit &&
                    <Button variant='primary' onClick={handleSave}>
                        {isNew ? 'Create' : 'Save Changes'}
                    </Button>}
                <Button variant='danger' onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </div>
    );
}

export default AgentInstructionEdit;